import { ClosestStation, StationSelection } from "./location-service";

export class LocalStorageService {
    private static readonly CLOSEST_STATION_KEY = 'closest-station-data';
    private static readonly STATION_SELECTION_KEY = 'station-selection-data';
    private static readonly LAST_LOCATION_UPDATE_KEY = 'last-location-update';
    private static readonly LEVEL_KEY = 'aurora-level-preference';
    private static readonly STATIONS_KEY = 'station-selection';


  public static saveClosestStationData(data: ClosestStation): void {
    try {
      localStorage.setItem(this.CLOSEST_STATION_KEY, JSON.stringify(data));
      console.debug(`Saved closest station: ${data.station.name} (${data.distance}km away)`);
    } catch (error) {
      console.error('Error saving closest station data:', error);
    }
  }

  public static getClosestStationData(): ClosestStation | null {
    try {
      const stored = localStorage.getItem(this.CLOSEST_STATION_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error('Error getting closest station data:', error);
    }
    return null;
  }

  public static saveLastLocationUpdate(date: Date): void {
    try {
      localStorage.setItem(this.LAST_LOCATION_UPDATE_KEY, date.toISOString());
      console.debug(`Saved last location update time: ${date.toISOString()}`);
    } catch (error) {
    console.error('Error saving last location update time:', error);
    }
  }

  public static getLastLocationUpdate(): Date | null {
    try {
      const stored = localStorage.getItem(this.LAST_LOCATION_UPDATE_KEY);
      if (stored) {
        return new Date(stored);
      }
    } catch (error) {
      console.error('Error getting closest station data:', error);
    }
    return null;
  }

  public static saveStationSelection(selection: StationSelection): void {
    try {
      localStorage.setItem(this.STATION_SELECTION_KEY, JSON.stringify(selection));
      console.debug(`Saved station selection: ${selection.mode} - ${selection.stationCodes.length} stations`);
    } catch (error) {
      console.error('Error saving station selection:', error);
    }
  }

  public static getStationSelection(): StationSelection {
    try {
      const stored = localStorage.getItem(this.STATION_SELECTION_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error('Error getting station selection:', error);
    }
    // Default to automatic mode
    return { mode: 'automatic', stationCodes: [] };
  }

  public static saveAuroraLevel(level: string): void {
    try {
      localStorage.setItem(this.LEVEL_KEY, level);
      console.debug(`Saved aurora level preference: ${level}`);
    } catch (error) {
      console.error('Error saving aurora level preference:', error);
    }
  }

  public static getAuroraLevel(): string {
    try {
      const stored = localStorage.getItem(this.LEVEL_KEY);
      if (stored) {
        return stored;
      }
    } catch (error) {
      console.error('Error getting aurora level preference:', error);
    }
    // Default to 'some' level
    return 'some';
  }

  public static saveStations(stationCodes: string[]): void {
    try {
      localStorage.setItem(this.STATIONS_KEY, JSON.stringify(stationCodes));
      console.debug(`Saved station codes: ${stationCodes.join(', ')}`);
    } catch (error) {
      console.error('Error saving station codes:', error);
    }
  }

  public static getStations(): string[] {
    try {
      const stored = localStorage.getItem(this.STATIONS_KEY);
      if (stored) {
        const selection = JSON.parse(stored) as StationSelection;
        return selection.stationCodes || [];
      }
    } catch (error) {
      console.error('Error getting station codes:', error);
    }
    return [];
  }
}
